<template>
  <div class="category">
    <div class="banxin">
      <div class="head" style="display: none">
        <div
          class="all goHome"
          @click="
            () => {
              this.$router.push({ name: 'index' });
            }
          "
        >
          首页
        </div>
        <!-- <div class='arrow'></div>
        <div class='all'>商品类别</div> -->
        <div class="arrow"></div>
        <div class="keyword">{{ classifyName }}</div>
        <!-- <div class='arrow'></div> --> 
      </div>
      <div style="padding:30px 0;">
        <div
        class="category-banner-container">
          <div class="fenleiTitle">
            <div class="rootName">{{rootName}}</div>
            <div class="fenleiBtn">收起筛选</div>
          </div>
          
          <div class="category-container" style="background: #ffffff">
            <div
              class="showClassify"
              style="padding: 20px;border: 1px solid #F5F5F5;"
            >
              <div v-if="categoryData.length > 1">
                <div
                  v-for="(subItem, index) in categoryData"
                  :key="index"
                  class="categoryData"
                >
                  <div
                    class="twocategory"
                    style="cursor: pointer"
                    v-if="index > 0"
                    :key="subItem.id"
                    @click.stop="
                      jumpCategory({ ...subItem, rootName: item.categoryName })
                    "
                  >
                    {{ subItem.categoryName }}
                  </div>
                  <div v-if="index > 0" class="threecategory">
                    <span
                      style="cursor: pointer"
                      v-for="(Item2, index) in subItem.childs"
                      :key="index"
                      @click.stop="
                        jumpCategory({ ...Item2, rootName: Item2.categoryName })
                      "
                    >
                      {{ Item2.categoryName }}</span
                    >
                  </div>
                </div>
              </div>
  
              <div v-else>
                <div class="categoryData">
                  <div
                    class="twocategory"
                    style="cursor: pointer"
                    @click.stop="
                      jumpCategory({
                        ...categoryData,
                        rootName: categoryData.categoryName,
                      })
                    "
                  >
                    {{ categoryData.categoryName }}
                  </div>
                  <div class="threecategory">
                    <span
                      style="cursor: pointer"
                      v-for="(Item2, index) in categoryData.childs"
                      :class="`${Item2.id == threeClassifyId ? activeSub : ''}`"
                      :key="index"
                      @click.stop="
                        jumpCategory({ ...Item2, rootName: Item2.categoryName })
                      "
                    >
                      {{ Item2.categoryName }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        <!-- <div class="category-bar">
          <span
            :class="`${item.id == classifyId ? 'active' : ''}`"
            v-for="item in curClassify"
            :key="item.id"
            @click="changeCategory(item)"
            >{{ item.categoryName }}</span
          >
        </div> -->
      </div>
      </div>
      
      <!-- <img class="banner" v-if="classifyBanner !== ''" :src="classifyBanner" alt=""> -->
      <div class="filter-container">
        
        <div class="sort">
          <div
            class="default"
            :class="index == '1' ? 'active' : ''"
            @click="defaultSort()"
          >
            综合
          </div>
          <div
            class="sales"
            :class="index == '3' ? 'active' : ''"
            @click="salesSort()"
          >
            销量
            <img
              v-show="index !== '3'"
              src="../../../../static/image/reduce@2x.png"
              alt=""
            />
            <img
              v-show="index == '3' && volume == 1"
              src="../../../../static/image/reduce2@2x.png"
              alt=""
            />
            <img
              v-show="index == '3' && volume == 2"
              src="../../../../static/image/reduce1@2x.png"
              alt=""
            />
          </div>
          <div
            class="price"
            :class="index == '2' ? 'active' : ''"
            @click="priceSort()"
          >
            价格
            <div class="arr">
              <div class="up" :class="type == 1 ? 'low' : ''"></div>
              <div class="down" :class="type == 2 ? 'high' : ''"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="content" v-if="noProduct == true">
        <div class="proList" v-loading="loading">
          <div class="noproduct">
            <img src="../../../../static/image/noorder@2x.png" alt="" />
            <p class="fs20 font-color-999">该分类没有商品～</p>
          </div>
        </div>
      </div>
      <div class="content content_yes" v-if="noProduct == false">
        <div class="proList" v-loading="loading">
          <div v-if="noProduct == false">
            <ProductList :productList="productList"></ProductList>
          </div>
        </div>
        <el-pagination
          v-if="noProduct == false && total > 20"
          :current-page.sync="page"
          :page-size="20"
          @current-change="handleCurrentChange"
          background
          layout="prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api_b2c";
import router from "@/router";
// import { funMixin } from "@/components/canvasShow/config/mixin";
import { listSearchMixin } from "@/config/mixin";
import ProductList from "@/components/base_b2c/productList";
import { mapGetters, mapMutations } from "vuex";
export default {
  mixins: [listSearchMixin],
  components: {
    ProductList,
  },
  data() {
    return {
      categoryData: [],
      category: 0,
      page: 1,
      index: "1",
      type: "",
      volume: "",
      total: 0,
      classifyId: 0,
      classifyIds:'',
      classifyId2:0,
      classifyName: "全部商品",
      noProduct: false,
      productList: [],
      classifyBanner: "",
      loading: false,
      threeClassifyId: 0,
      activeSub:'',
      componentContentB2c:{},
      id:'',
      rootName:""
    };
  },
  computed: {
    ...mapGetters(["classify"]),
    curClassify() {
      var classifyData = JSON.parse(this.$route.query.classifyData);
      let rootName = classifyData.rootName || classifyData.categoryName;
      let arr = [];
      console.log(classifyData);
      this.classifyId = classifyData.parentId;
      console.log(this.classify);
      this.categoryData = classifyData.childs;
      // let obj = {};
      // this.classify.map((item) => {
      //   if (item.categoryName == rootName || item.id == classifyData.parentId) {
      //     obj = item;
      //     obj.bannerImg = item.childs[0] ? item.childs[0].classifyImage : "";
      //     arr = item.childs;
      //   }
      // });
      // let _arr = [{ ...obj, categoryName: "全部商品" }, ...arr];
      // console.log(_arr);
      // this.categoryData = [];
      return this.categoryData;
    },
  },
  watch: {
    curClassify() {
      this.initData();
    },
  },
  mounted() {
    this.initData();
    this.componentContentB2c = this.$store.state.componentContentB2c
    this.categoryData = []
    // this.categoryData = this.curClassify
    this.category = this.classifyId;
    let categoryDataList = this.componentContentB2c.category
    console.log(categoryDataList);
    for(let i=0;i<categoryDataList.length;i++){
      if(this.id == categoryDataList[i].id){
        this.categoryData = categoryDataList[i].childs
      }
    }
    console.log(this.categoryData);
    console.log(this.category);
    // this.getClassifyInfo();
    
    
  },
  methods: {
    // 跳转到类别主页
    jumpCategory(item) {
      
      this.activeSub = 'activeSub'
      this.classifyId = item.id;
      this.classifyIds = ''
      this.threeClassifyId = item.id;
      this.getClaasifyProducts();
      this.classifyId = item.parentId;

      // router.push({
      //   name: "category",
      //   query: {
      //     classifyData: JSON.stringify(item),
      //   },
      // });
    },
    // getClassifyInfo() {
    //   let self = this;
    //   let _url = api.getClassify + ``;
    //   // if (self.activeName !== "all") {
    //   //   _url += `&classifyId=${self.activeName}`;
    //   // }
    //   let params = {
    //     url: _url,
    //     method: "GET",
    //     data: {},
    //   };
    //   this.sendReq(params, (res) => {
    //     if (res.code === "200") {
    //       // self.categoryData = res.data;
    //       // self.total = res.data.page.total;
    //     } else {
    //       self.$message({
    //         message: res.message,
    //         type: "warning",
    //       });
    //     }
    //   });
    // },
    initData() {
      
      var classifyData = JSON.parse(this.$route.query.classifyData);
      // console.log(classifyData);
      // var classifyData = this.categoryData;
      this.classifyBanner = classifyData.classifyImage;
      this.classifyName = classifyData.categoryName;
      this.id = classifyData.id
      this.rootName = classifyData.rootName || classifyData.categoryName;
      if (classifyData.childs.length > 0) {
        
        this.classifyId = classifyData.id;
        this.classifyId2 = classifyData.id;
        this.classifyIds = ''
        for (let i = 0; i < this.curClassify.length; i++) {
          if (this.curClassify[i].id == this.classifyId) {
            this.changeCategory(this.curClassify[i]);
          }
        }
        this.page = 1;
        this.getClaasifyProducts();
      } else {
        
        this.classifyId = classifyData.id;
        this.classifyId2 = classifyData.id;
        this.classifyIds = ''
        this.page = 1;
        this.getClaasifyProducts();
        let dateClass = this.curClassify
        for (let j = 0; j < dateClass.length; j++) {
          if (dateClass[j].id == classifyData.parentId) {
            this.categoryData = dateClass[j];
          }
        }
        
        this.classifyId = classifyData.parentId;
        
      }
    },
    changeCategory(obj) {
      this.page = 1;
      // if (sessionStorage.getItem("curentPage2")) {
      //   sessionStorage.removeItem("curentPage2");
      // }
      if (obj.categoryName != "全部商品") {
        this.categoryData = obj;
      } else {
        this.categoryData = [];
      }
      
      this.classifyId = obj.id;
      this.classifyId2  = obj.id;
      this.category = obj.id;
      this.classifyIds = ''
      this.activeSub = ''
      console.log(obj);
      this.$nextTick(() => {
        // this.classifyId = this.classifyId3
        this.getClaasifyProducts();
      });
    },
    
    // 获取分类商品
    getClaasifyProducts() {
      let self = this;
      self.loading = true;
      console.log(self.page)
      if (sessionStorage.getItem("curentPage2") ) {
        self.page = sessionStorage.getItem("curentPage2");
      }
      let params = {
        url: api.getClaasifyProducts,
        method: "GET",
        payload: {
          category: 1,
          classifyId: self.classifyId,
          classifyIds:self.classifyIds,
          type: self.type,
          volume: self.volume,
          page: self.page,
          pageSize: 20,
        },
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          // console.log(res)
          self.productList = res.data.list;
          self.total = res.data.total;
          if (res.data.list.length < 1) {
            self.noProduct = true;
          } else {
            self.noProduct = false;
          }
          self.loading = false;
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    // 分页器跳转
    handleCurrentChange(val) {
      this.page = val;
      sessionStorage.setItem("curentPage2", this.page);
      
      this.classifyId = this.classifyId2
      this.getClaasifyProducts();
    },
    // 默认排序
    defaultSort() {
      this.type = "";
      this.volume = "";
      this.index = "1";
      this.page = 1;
      this.getClaasifyProducts();
    },
    // 价格排序
    priceSort() {
      if (this.type !== 1) {
        this.type = 1;
      } else {
        this.type = 2;
      }
      this.page = 1;
      this.volume = "";
      this.index = "2";
      this.classifyId = this.classifyId2
      if(this.threeClassifyId == 0){
        this.classifyIds = ''
      }else{
        this.classifyIds = this.threeClassifyId
      } 
      this.getClaasifyProducts();
    },
    // 销量排序
    salesSort() {
      if (this.volume !== 1) {
        this.volume = 1;
      } else {
        this.volume = 2;
      }
      this.page = 1;
      this.type = "";
      this.index = "3";
      this.classifyId = this.classifyId2
      if(this.threeClassifyId == 0){
        this.classifyIds = ''
      }else{
        this.classifyIds = this.threeClassifyId
      }
      this.getClaasifyProducts();
    },
  },
};
</script>
<style lang = "scss" scoped>
.categoryData {
  display: flex;
  padding-left: 20px;
  justify-content: left !important;
  margin: 0;
  .twocategory {
    min-width: 80px;
    margin-right: 40px;
    font-size: 16px;
    font-weight: bold;
    color: #000000;
    &:hover {
      color: #f77b0b;
    }
  }
  .threecategory {
    width: 100%;
    font-size: 16px;
    color: #606266;
    padding-bottom: 20px;
    /* border-bottom: 1px dashed #e5e5e5; */
    text-align: left !important;
    span {
      margin-right: 30px;
      &:hover {
        color: #f77b0b;
      }
    }
  }
}
.category {
  width: 100%;
  height: 100%;
  background-color: #f0f0f0;
  padding-bottom: 143px;
  text-align: center;
  .banxin {
    width: 90%;
    max-width: 1612px;
    height: 100%;
    margin: 0 auto;
    .head {
      width: 100%;
      height: 64px;
      line-height: 64px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #666666;
      .all {
        margin-left: 10px;
        margin-right: 10px;
      }
      .keyword {
        margin: 0 10px;
        color: #ff7800;
      }
      .goHome:hover {
        /* color: #ff7800; */
        cursor: pointer;
      }
      .arrow {
        background-image: url("../../../../static/image/xiangyou@2x.png");
        width: 5px;
        height: 10px;
      }
    }
    .category-banner-container {
      width: 100%;
      //height: 160px;
      border-radius: 18px;
      display: block;
      position: relative;
      background: #fff;
      .fenleiTitle{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 30px;
        .rootName{
          font-size: 18px;
          font-weight: 600;
        }
        .fenleiBtn{
          padding:5px 10px;
          background-color: #F5F5F5;
        }
      }
      .category-bar {
        display: flex;
        height: 38px;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background: rgba(0, 0, 0, 0.5);
        align-items: stretch;
        padding: 0 180px;
        overflow: hidden;
        span {
          display: flex;
          min-width: 112px;
          padding: 0 10px;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          cursor: pointer;
        }
        span:hover {
          background: rgba(0, 0, 0, 0.3);
        }
        span.active {
          background: rgba(0, 0, 0, 0.3);
        }
      }
    }
    .dz_banner {
      background: url(../../../assets/images/dz-banner.png) no-repeat center;
      background-size: cover;
    }
    .rou_lei_dan_bai {
      background: url(../../../assets/images/rou_lei_dan_bai.png) no-repeat center;
      background-size: cover;
    }
    .fu_zhuang_fu_shi {
      background: url(../../../assets/images/fu_zhuang_fu_shi.png) no-repeat center;
      background-size: cover;
    }
    .shi_pin_bai_huo {
      background: url(../../../assets/images/shi_pin_bai_huo.png) no-repeat center;
      background-size: cover;
    }
    .stationery {
      background: url(../../../assets/images/stationery.png) no-repeat center;
      background-size: cover;
    }

    .banner {
      width: 100%;
      height: 356px;
      margin-bottom: 25px;
    }
    .filter-container {
      .sort {
        box-sizing: border-box;
        width: 100%;
        height: 72px;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        color: #666666;
        padding: 0 27px;
        font-size: 14px;
        margin-bottom: 20px;
        & > div {
          margin-right: 36px;
          display: flex;
          align-items: center;
        }
        .default {
          cursor: pointer;
        }
        .sales {
          cursor: pointer;
          img {
            margin-left: 3px;
            width: 9px;
            height: 12px;
            vertical-align: middle;
          }
        }
        .price {
          display: flex;
          cursor: pointer;
          flex-direction: initial;
          .arr {
            vertical-align: middle;
            width: 12px;
            margin-left: 3px;
            .up {
              width: 0;
              height: 0;
              border: 4px solid transparent;
              border-bottom-color: #999999;
            }
            .down {
              width: 0;
              height: 0;
              border: 4px solid transparent;
              border-top-color: #999999;
              margin-top: 3px;
            }
          }
        }
        .active {
          color: #ff7800;
          .arr {
            .high {
              border-top-color: #ff7800;
            }
            .low {
              border-bottom-color: #ff7800;
            }
          }
        }
      }
    }
    .content {
      background-color: #ffffff;
      width: 100%;
      padding: 0;
      box-sizing: border-box;
      .noproduct {
        width: 100%;
        text-align: center;
        padding: 200px 0;
      }
      >>> .el-pagination {
        text-align: center;
        .el-pager {
          li {
            background-color: #ffffff;
          }
          li:not(.disabled):hover {
            color: #ff7800;
          }
          li:not(.disabled).active {
            background-color: #ff7800;
          }
          li:not(.disabled).active:hover {
            color: #f4f4f5;
          }
        }
        button:not(:disabled) {
          background-color: #ffffff;
        }
      }
    }
    .content_yes {
      background-color: transparent;
    }
  }
  .proList {
    min-height: 500px;
    margin-right: -20px;
  }
}
.activeSub {
  color: #f77b0b;
}
</style>



// WEBPACK FOOTER //
// src/views/b2c/category/index.vue